import styled, { css } from 'styled-components';

export const SelectContainer = styled.button<{ $isFullWidth: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  height: 100%;
  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(2)}`};

  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  cursor: pointer;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    css`
      width: 100%;
    `};
`;

export const IconContainer = styled.span<{ $open: boolean }>`
  transform: ${({ $open }) => `rotate(${$open ? 180 : 0}deg)`};
  transition: transform 200ms;

  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
